import {NgModule} from "@angular/core";
import {CompaniesComponent} from "./leadvertorial/companies.component";

@NgModule({
	declarations: [
		CompaniesComponent
	],
	imports: []
})
export class ImportsModule {
}
